export default __webpack_public_path__ + "static/logo_white-433e23ab6325140e98663fce439194ff.png";